import {
	gridGutterHalf,
} from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/layout";

export const hotelsEmerging = `
	.hotelsEmerging {
		display: flex;
		width: 52vw;
		max-width: 752px;
		min-width: 272px;
		height: 291px;
		background: url(https://maxmilhas.s3.amazonaws.com/assets/img/hotels-banner.svg) no-repeat;
		background-color: #edf4f9;
		&__content {
			padding: ${gridGutterHalf}px;
			@media(min-width: 1024px) {
				position: absolute;
				padding: 0;
				top: 27%;
				left: 63%;
				text-align: center;
				max-width: 190px;
			}
			@media(min-width: 1366px) {
				text-align: left;
				left: 57%;
				max-width: 290px;
			}
			h2, p {
				color: #333;
				font-weight: 600;
			}
			h4 {
				color: #333;
				font-weight: 600;
				margin-bottom: ${gridGutterHalf}px;
			}
			a {
				color: #1eada9;
				font-weight: 600;
				outline: none;
				text-decoration: underline !important;
			}
		}
	}
`;